export class PetEnvironmentModel {
    pet_no: number
    combo_index0: string
    combo_index1: string
    combo_index2: string
    combo_index3: string
    combo_index4: string
    combo_index5: string
    combo_index6: string
    combo_index7: string
    combo_index8: string
    combo_index9: string
    combo_index10: string
    combo_index11: string
    combo_index12: string
    combo_index13: string
    combo_index14: string

    constructor(
        pet_no: number,
        combo_index0: string,
        combo_index1: string,
        combo_index2: string,
        combo_index3: string,
        combo_index4: string,
        combo_index5: string,
        combo_index6: string,
        combo_index7: string,
        combo_index8: string,
        combo_index9: string,
        combo_index10: string,
        combo_index11: string,
        combo_index12: string,
        combo_index13: string,
        combo_index14: string
    ) {
        this.pet_no = pet_no
        this.combo_index0 = combo_index0
        this.combo_index1 = combo_index1
        this.combo_index2 = combo_index2
        this.combo_index3 = combo_index3
        this.combo_index4 = combo_index4
        this.combo_index5 = combo_index5
        this.combo_index6 = combo_index6
        this.combo_index7 = combo_index7
        this.combo_index8 = combo_index8
        this.combo_index9 = combo_index9
        this.combo_index10 = combo_index10
        this.combo_index11 = combo_index11
        this.combo_index12 = combo_index12
        this.combo_index13 = combo_index13
        this.combo_index14 = combo_index14
    }
}